import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SEO_META } from "@/lib/site";

const setMeta = (name, content, attr = "name") => {
  if (typeof document === "undefined") return;
  let tag = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
};

const setLink = (rel, href) => {
  if (typeof document === "undefined") return;
  let tag = document.head.querySelector(`link[rel="${rel}"]`);
  if (!tag) {
    tag = document.createElement("link");
    tag.setAttribute("rel", rel);
    document.head.appendChild(tag);
  }
  tag.setAttribute("href", href);
};

export default function useDocumentMeta(overrides = {}) {
  const { pathname } = useLocation();
  useEffect(() => {
    const fallback = SEO_META["/"];
    const fromMap = SEO_META[pathname] || fallback;
    const title = overrides.title || fromMap.title;
    const description = overrides.description || fromMap.description;
    const url = `https://shadyacrescaravanpark.com.au${pathname}`;

    document.title = title;
    setMeta("description", description);
    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");
    setMeta("og:url", url, "property");
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);
    setLink("canonical", url);
  }, [pathname, overrides.title, overrides.description]);
}
